import { useCallback, useRef, useState } from 'react';

import { Slideshow } from 'components/Slideshow/Slideshow';
import { useElementReachedEffect } from 'hooks/viewport/useElementReachedEffect';
import { useViewportBreakpointValue } from 'hooks/viewport/useViewportBreakpointValue';
import type { CmsApiImageGalleryBlockData } from 'modules/cms/api/types/blocks/CmsApiImageGalleryBlock';
import { showModal } from 'zustand-stores/modalStore';

type Props = {
  data: CmsApiImageGalleryBlockData;
  blockIndex: number;
  fullWidthLayout?: boolean;
};

export function CmsImageGalleryBlock({
  data: { images },
  blockIndex,
  fullWidthLayout,
}: Props) {
  const [show, setShow] = useState(blockIndex > 2);
  const lazyRef = useRef<HTMLDivElement>(null);

  useElementReachedEffect({
    ref: lazyRef,
    offset: { top: 200 },
    onReach: useCallback(() => setShow(true), []),
  });

  const size = useViewportBreakpointValue({
    xs: 240,
    sm: 240,
    md: 240,
    lg: fullWidthLayout ? 360 : 240,
  });

  const openMediaGallery = useCallback(
    ({ itemIndex }: { itemIndex: number }) => {
      showModal(
        'MEDIA_GALLERY',
        // @ts-expect-error TS(2322): Type 'SlideshowData[]' is not assignable to type '... Remove this comment to see the full error message
        { items: images, itemIndex },
      );
    },
    [images],
  );

  if (!show) return <div ref={lazyRef} />;

  return (
    <Slideshow
      carouselId={`cms-image-gallery-carousel-${blockIndex}`}
      // @ts-expect-error TODO fix me
      items={images}
      qaId="cms-image-gallery"
      onClickIndex={openMediaGallery}
      size={size}
    />
  );
}
